export default "__VITE_ASSET__Dtzcb1vQ__"